module.exports = __webpack_public_path__ + "static/img/CD.63690c95.svg";